import type { AnimationSegment } from 'lottie-web';
export const LOADING_SEGMENTS: AnimationSegment[] = [
  [0, 30],
  [31, 60],
];
